/* src/app/private/components/leads/lead-profile-middle-screen/lead-profile-middle-screen.component.scss */
.profile-input {
  background-color: var(--secondry-light-gray) !important;
  border: none !important;
}
.profile-select {
  background-color: var(--secondry-light-gray) !important;
  border: none !important;
}
.p-datepicker-inpu {
  background-color: var(--secondry-light-gray) !important;
  border: none !important;
}
/*# sourceMappingURL=lead-profile-middle-screen.component.css.map */
